import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface WelcomeHostHouseIconProps {
  width?: number;
  height?: number;
}

const WelcomeHostHouseIcon: React.FC<WelcomeHostHouseIconProps> = ({
  width = 44,
  height = 41,
}) => (
  <Svg width={width} height={height} viewBox="0 0 44 41" fill="none">
    <Path
      d="M43.5494 19.8591L22.9886 0.39447C22.4335 -0.13149 21.5699 -0.13149 21.0189 0.39447L0.454045 19.8591C-0.125768 20.4058 -0.154553 21.3252 0.392363 21.9091C0.939279 22.4931 1.84806 22.522 2.42788 21.9712L4.93629 19.5941V39.5515C4.93629 40.3508 5.5819 41.001 6.37554 41.001H37.6279C38.4215 41.001 39.0671 40.3508 39.0671 39.5515V19.5941L41.5755 21.9712C41.8552 22.2363 42.2088 22.3647 42.5625 22.3647C42.9449 22.3647 43.3273 22.2114 43.6111 21.9091C44.1539 21.3252 44.1292 20.4099 43.5494 19.8591ZM36.1886 18.0162V38.102H7.81479V18.0162C7.81479 17.689 7.70377 17.3908 7.52283 17.1465L22.0017 3.43841L36.4806 17.1465C36.2997 17.3908 36.1886 17.689 36.1886 18.0162Z"
      fill="#64E280"
    />
    <Path
      d="M17.8896 23.8142H22.8242L19.5345 33.3395L27.7588 18.8445H22.8242L24.4691 10.5617L17.8896 23.8142Z"
      fill="#64E280"
    />
  </Svg>
);

export default WelcomeHostHouseIcon;
